import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';
import EN from './locale/en.json';
import FR from './locale/fr.json';
import LT from './locale/lt.json';
import IT from './locale/it.json';
import RO from './locale/ro.json';
import DE from './locale/de.json';
import ES from './locale/es.json';
import NL from './locale/nl.json';
import AL from './locale/al.json';
import PT from './locale/pt.json';
import EL from './locale/el.json';
import PL from './locale/pl.json';
import ET from './locale/et.json';
import CA from './locale/ca.json';
import BS from './locale/bs.json';
import DA from './locale/da.json';
import HR from './locale/hr.json';
import LV from './locale/lv.json';
import HU from './locale/hu.json';
import NO from './locale/no.json';
import PTBR from './locale/pt-br.json';
import SL from './locale/sl.json';
import FI from './locale/fi.json';
import SV from './locale/sv.json';
import TR from './locale/tr.json';
import IS from './locale/is.json';
import CS from './locale/cs.json';
import BG from './locale/bg.json';
import MK from './locale/mk.json';
import RU from './locale/ru.json';
import SE from './locale/se.json';
import UK from './locale/uk.json';
import HY from './locale/hy.json';
import HE from './locale/he.json';
import AR from './locale/ar.json';
import KA from './locale/ka.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: EN },
    fr: { translation: FR },
    lt: { translation: LT },
    it: { translation: IT },
    ro: { translation: RO },
    de: { translation: DE },
    es: { translation: ES },
    nl: { translation: NL },
    al: { translation: AL },
    pt: { translation: PT },
    el: { translation: EL },
    pl: { translation: PL },
    et: { translation: ET },
    ca: { translation: CA },
    bs: { translation: BS },
    da: { translation: DA },
    hr: { translation: HR },
    lv: { translation: LV },
    hu: { translation: HU },
    no: { translation: NO },
    'pt-br': { translation: PTBR },
    sl: { translation: SL },
    fi: { translation: FI },
    sv: { translation: SV },
    tr: { translation: TR },
    is: { translation: IS },
    cs: { translation: CS },
    bg: { translation: BG },
    mk: { translation: MK },
    ru: { translation: RU },
    se: { translation: SE },
    uk: { translation: UK },
    hy: { translation: HY },
    he: { translation: HE },
    ar: { translation: AR },
    ka: { translation: KA },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: false },
});
